export const plans = {
    trial: "1.00",
    monthly: import.meta.env.VITE_APP_MENSAL_PRICE || "99.00",
    semiannual: import.meta.env.VITE_APP_SEMIANNUAL_PRICE || "474.00",
    annual: import.meta.env.VITE_APP_ANNUAL_PRICE || "828.00"
}

export const plansPrices = {
    trial: "R$ 1,00",
    monthly: "R$ 99,00",
    semiannual: "R$ 474,00",
    annual: "R$ 828,00"
}

export const rawPlanPrices = {
    trial: 1.00,
    monthly: 99.00,
    semiannual: 474.00,
    annual: 828.00
} as const

export const plansName = {
    trial: "Teste",
    monthly: "Mensal",
    semiannual: "Semianual",
    annual: "Anual"
}

export const plansMonths = {
    trial: "teste",
    monthly: "mês",
    semiannual: "6 meses",
    annual: "12 meses"
}

export const plansDescriptions = {
    trial: "Teste por 7 dias",
    monthly: "Acesso mensal completo",
    semiannual: "Acesso por 6 meses",
    annual: "Acesso por 12 meses"
}